import React from 'react';
import { ShieldCheckIcon, LockIcon, DownloadIcon, HeartIcon } from 'lucide-react';
const trustItems = [{
  Icon: DownloadIcon,
  label: 'Acceso Inmediato'
}, {
  Icon: LockIcon,
  label: 'Pago 100% Seguro'
}, {
  Icon: ShieldCheckIcon,
  label: 'Garantía 7 Días'
}, {
  Icon: HeartIcon,
  label: '10,000+ Mamás Felices'
}];
export function TrustStrip() {
  return <section className="bg-white border-y border-[#F9A8B7]/20 py-4 md:py-6 px-4" data-id="element-172">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6" data-id="element-173">
        {trustItems.map(({
        Icon,
        label
      }, index) => <div key={index} className="flex items-center justify-start md:justify-center gap-2 md:gap-3" data-id="element-174">
            <div className="bg-[#FFF1F4] p-1.5 md:p-2 rounded-full flex-shrink-0" data-id="element-175">
              <Icon className="w-3.5 h-3.5 md:w-5 md:h-5 text-[#F9A8B7]" strokeWidth={2.5} data-id="element-176" />
            </div>
            <span className="font-bold text-[11px] md:text-sm text-[#2D1F1A] leading-tight" data-id="element-177">
              {label}
            </span>
          </div>)}
      </div>
    </section>;
}